const getters = {
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickname: state => state.user.name,
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  userInfo: state => state.user.info,
  addRouters: state => state.permission.addRouters,
  multiTab: state => state.app.multiTab,
  lang: state => state.i18n.lang,
  // 从后台获取的用户 按钮权限
  buttons: state => state.user.buttons,
  userId: state => state.user.userId,
  enterpriseId: state => state.user.enterpriseId,
  enterpriseName: state => state.user.enterpriseName,
  userType: state => state.user.userType,
  teamId: state => state.user.teamId,
  workType: state => state.user.workType
}

export default getters
